import React from "react";
import { IconProps } from "./IconProps";

const CaretCircleDownIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2C8.41775 2 6.87103 2.46919 5.55544 3.34824C4.23985 4.22729 3.21447 5.47672 2.60897 6.93853C2.00347 8.40034 1.84504 10.0089 2.15372 11.5607C2.4624 13.1126 3.22433 14.538 4.34315 15.6569C5.46197 16.7757 6.88743 17.5376 8.43928 17.8463C9.99113 18.155 11.5997 17.9965 13.0615 17.391C14.5233 16.7855 15.7727 15.7602 16.6518 14.4446C17.5308 13.129 18 11.5822 18 10C17.9978 7.87895 17.1542 5.84542 15.6544 4.34562C14.1546 2.84581 12.121 2.00224 10 2ZM10 16.7692C8.66117 16.7692 7.35241 16.3722 6.23922 15.6284C5.12603 14.8846 4.2584 13.8274 3.74605 12.5905C3.2337 11.3536 3.09965 9.99249 3.36084 8.67939C3.62203 7.36629 4.26674 6.16012 5.21343 5.21343C6.16013 4.26674 7.36629 3.62203 8.67939 3.36084C9.99249 3.09965 11.3536 3.2337 12.5905 3.74605C13.8274 4.25839 14.8846 5.12602 15.6284 6.23922C16.3722 7.35241 16.7692 8.66117 16.7692 10C16.7672 11.7947 16.0534 13.5153 14.7843 14.7843C13.5153 16.0534 11.7947 16.7672 10 16.7692ZM13.5123 10.7954C13.5695 10.8526 13.6148 10.9204 13.6458 10.9951C13.6767 11.0698 13.6927 11.1499 13.6927 11.2308C13.6927 11.3116 13.6767 11.3917 13.6458 11.4664C13.6148 11.5411 13.5695 11.609 13.5123 11.6662C13.4551 11.7233 13.3873 11.7687 13.3126 11.7996C13.2378 11.8306 13.1578 11.8465 13.0769 11.8465C12.9961 11.8465 12.916 11.8306 12.8413 11.7996C12.7666 11.7687 12.6987 11.7233 12.6415 11.6662L10 9.02384L7.35846 11.6662C7.30129 11.7233 7.23341 11.7687 7.15871 11.7996C7.084 11.8306 7.00394 11.8465 6.92308 11.8465C6.84222 11.8465 6.76215 11.8306 6.68745 11.7996C6.61275 11.7687 6.54487 11.7233 6.48769 11.6662C6.43052 11.609 6.38516 11.5411 6.35422 11.4664C6.32328 11.3917 6.30735 11.3116 6.30735 11.2308C6.30735 11.1499 6.32328 11.0698 6.35422 10.9951C6.38516 10.9204 6.43052 10.8526 6.48769 10.7954L9.56462 7.71846C9.62177 7.66124 9.68964 7.61585 9.76435 7.58489C9.83905 7.55392 9.91913 7.53798 10 7.53798C10.0809 7.53798 10.161 7.55392 10.2357 7.58489C10.3104 7.61585 10.3782 7.66124 10.4354 7.71846L13.5123 10.7954Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 18C14.41 18 18 14.41 18 10C18 5.59 14.41 2 10 2C5.59 2 2 5.59 2 10C2 14.41 5.59 18 10 18ZM10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17C6.14 17 3 13.86 3 10C3 6.14 6.14 3 10 3Z"
            fill={color}
          />
          <path
            d="M9.65 12.23C9.85 12.43 10.16 12.43 10.36 12.23L13.48 9.11C13.68 8.91 13.68 8.6 13.48 8.4C13.28 8.2 12.97 8.2 12.77 8.4L10 11.17L7.23 8.4C7.13 8.3 7.00001 8.25 6.88001 8.25C6.76001 8.25 6.62001 8.3 6.53 8.4C6.33001 8.6 6.33 8.91 6.53 9.11L9.65 12.23Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3.25C13.4783 3.25 11.0132 3.99777 8.91648 5.39876C6.81975 6.79975 5.18555 8.79103 4.22053 11.1208C3.25552 13.4505 3.00302 16.0141 3.49499 18.4874C3.98695 20.9607 5.20127 23.2325 6.98439 25.0156C8.76751 26.7987 11.0393 28.0131 13.5126 28.505C15.9859 28.997 18.5495 28.7445 20.8792 27.7795C23.209 26.8144 25.2002 25.1802 26.6012 23.0835C28.0022 20.9868 28.75 18.5217 28.75 16C28.746 12.6197 27.4015 9.379 25.0112 6.98877C22.621 4.59854 19.3803 3.25397 16 3.25ZM16 27.25C13.775 27.25 11.5999 26.5902 9.74983 25.354C7.89978 24.1179 6.45784 22.3609 5.60635 20.3052C4.75487 18.2495 4.53208 15.9875 4.96616 13.8052C5.40025 11.6229 6.47171 9.61839 8.04505 8.04505C9.61839 6.47171 11.6229 5.40025 13.8052 4.96617C15.9875 4.53208 18.2495 4.75487 20.3052 5.60636C22.3609 6.45784 24.1179 7.89978 25.354 9.74984C26.5902 11.5999 27.25 13.775 27.25 16C27.2467 18.9827 26.0604 21.8422 23.9513 23.9513C21.8422 26.0604 18.9827 27.2467 16 27.25ZM21.53 13.47C21.6704 13.6106 21.7493 13.8012 21.7493 14C21.7493 14.1988 21.6704 14.3894 21.53 14.53L16.53 19.53C16.3894 19.6705 16.1987 19.7493 16 19.7493C15.8012 19.7493 15.6106 19.6705 15.47 19.53L10.47 14.53C10.3375 14.3878 10.2654 14.1998 10.2688 14.0055C10.2723 13.8112 10.351 13.6258 10.4884 13.4884C10.6258 13.351 10.8112 13.2723 11.0055 13.2688C11.1998 13.2654 11.3878 13.3375 11.53 13.47L16 17.9387L20.47 13.47C20.6106 13.3295 20.8012 13.2507 21 13.2507C21.1987 13.2507 21.3894 13.3295 21.53 13.47Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CaretCircleDownIcon;
